import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getInvoicePaymentMethods = ({
  calculationId,
}: {
  calculationId: string;
}): Promise<ISelectModel<string>[]> =>
  API.get(`/api/accommodation/calculations/${calculationId}/payment-methods`).then(
    response => response?.data,
  );
